import { gql } from 'graphql-tag';

const PROFILE_FRAGMENT = gql`
    fragment UserProfileList on UserProfile {
        situationWhatIsYourCurrentPropertyGoal
        situationDoYouHaveAMortgage
        situationWhenDoesYourCurrentMortgageRateExpire
        situationAreYouAFirstTimeBuyer
        situationAreYouSellingAProperty
        situationIsItAlreadyOnTheMarket
        situationAreYouAPropertyInvestor
        situationAreYouLookingToBuy
        situationAreYouAHomeowner
    }
`;

export default gql`
    ${PROFILE_FRAGMENT}
    query getUserProfile {
        user {
            loggedIn
            userId
            profile {
                ...UserProfileList
            }
            trackedProperties(offset: 0, limit: 1) {
                total
                items {
                    relationship
                    property {
                        uprn
                        address {
                            fullAddress
                            uprn
                        }
                        saleEstimate {
                            lowerPrice
                            currentPrice
                            upperPrice
                            confidenceLevel
                        }
                    }
                }
            }
        }
    }
`;
